module.exports = __webpack_public_path__ + "img/tribes_map.cf801ed8.jpg";